module.exports = __webpack_public_path__ + "img/notification.01ce1feb.png";